import { PaymentMode, ChequeStatus } from './enums/PaymentMode.enum';

export enum VoucherPaymentStatus {
  PENDING_APPROVAL = 'Pending Approval',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
}

export interface VoucherPayment {
  id: string;
  voucherId: string;
  paymentDate: string;
  paidAmount: number;
  paymentMode: PaymentMode | string;
  receiverName?: string;
  status: VoucherPaymentStatus | string;
  approvedBy?: string | null;
  approvedDate?: string | null;
  rejectionNotes?: string | null;
  chequeNumber?: string | null;
  chequeDate?: string | null;
  chequeStatus?: ChequeStatus | null;
  chequeRealizedDate?: string | null;
  bankName?: string | null;
  accountNumber?: string | null;
  paymentRefNo?: string | null;
  bankAccountId?: string | null;
  bankAccountName?: string | null;
  chequeDetails?: string;
  bankAccount?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface PaginatedVoucherPaymentResponse {
  data: VoucherPayment[];
  totalItems: number;
  currentPage: number;
  totalPages: number;
}

export interface VoucherPaymentFormValues {
  id: string;
  voucherId: string;
  receiverName: string;
  paymentDate: string;
  amount: string;
  paymentMode: PaymentMode | '';
  chequeNumber: string;
  chequeDate: string;
  bankAccountId: string;
  transactionReference: string;
}

export interface VoucherPaymentPayload {
  id?: string;
  voucherId?: string;
  receiverName: string;
  paymentDate: string;
  paidAmount: number;
  paymentMode: PaymentMode | string;
  chequeNumber?: string;
  chequeDate?: string;
  bankAccountId?: string;
  paymentRefNo?: string;
}

export interface VoucherPaymentGridProps {
  voucherId: string;
  state: boolean;
  banks: Array<{ id: string; bankName: string; accountNumber: string }>;
  onBanksFetch?: () => void;
  onPaymentModeChange?: (paymentMode: PaymentMode | '') => void;
}

export interface VoucherPaymentActionMenuProps {
  rowId: string | number;
  id: string;
  voucherId: string;
  status: VoucherPaymentStatus | string;
  paymentMode: PaymentMode | string;
  banks: Array<{ id: string; bankName: string; accountNumber: string }>;
  fetchPayments: () => void;
  deletePayment: (id: string) => void;
  onBanksFetch?: () => void;
  onPaymentModeChange?: (paymentMode: PaymentMode | '') => void;
}

export interface ViewVoucherPaymentDialogProps {
  open: boolean;
  onClose: () => void;
  payment: VoucherPayment | null;
}

export interface AddVoucherPaymentDialogProps {
  open: boolean;
  handleClose: () => void;
  title: string;
  subtitle: string;
  children: React.ReactNode;
  onSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
  buttonLabel?: string;
  buttonDisabled?: boolean;
  onSaveClick?: () => void;
  paymentModeSection?: React.ReactNode;
}
